import { render, staticRenderFns } from "./SactinAdministrative.vue?vue&type=template&id=bc302514&scoped=true&"
import script from "./SactinAdministrative.vue?vue&type=script&lang=js&"
export * from "./SactinAdministrative.vue?vue&type=script&lang=js&"
import style0 from "./SactinAdministrative.vue?vue&type=style&index=0&id=bc302514&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc302514",
  null
  
)

export default component.exports